import { Grid, lighten, Typography } from '@mui/material';
import { Fragment } from 'react';

interface Props {
  i18n?: Record<string, string>;
  oldData?: Record<string, unknown>;
  newData?: Record<string, unknown>;
}

const hasValue = (value: unknown) => value !== undefined && value !== null && value !== '';

const formatValue = (value: unknown) => {
  if (!hasValue(value)) {
    return '–';
  }

  if (typeof value === 'object') {
    return JSON.stringify(value, undefined, 2);
  }

  if (value === true) {
    return 'Ja';
  }
  if (value === false) {
    return 'Nein';
  }

  return value as string | number;
};

export function AuditFieldGrid({ i18n = {}, oldData = {}, newData = {} }: Props) {
  const allKeys = Array.from(new Set([...Object.keys(oldData), ...Object.keys(newData)])).filter(
    (key) => !['id', 'createdAt', 'updatedAt', '__caslSubjectType__'].includes(key),
  );

  return (
    <Grid container>
      {allKeys.map((key) => {
        const oldValue = formatValue(oldData[key]);
        const newValue = formatValue(newData[key]);
        const hasDiff = oldValue !== newValue;

        return (
          <Fragment key={key}>
            <Grid padding={1} size={12}>
              <Typography fontWeight="bold">{i18n[key] ?? key}</Typography>
            </Grid>

            <Grid
              padding={1}
              size={6}
              sx={(theme) => ({
                backgroundColor:
                  hasDiff && hasValue(oldData[key]) ? lighten(theme.palette.error.light, 0.25) : undefined,
              })}
            >
              <Typography variant="body2">{oldValue}</Typography>
            </Grid>

            <Grid
              padding={1}
              size={6}
              sx={(theme) => ({
                backgroundColor:
                  hasDiff && hasValue(newData[key]) ? lighten(theme.palette.secondary.light, 0) : undefined,
              })}
            >
              <Typography variant="body2">{newValue}</Typography>
            </Grid>
          </Fragment>
        );
      })}
    </Grid>
  );
}
